export function toViewableFactUrl(rawUrl: string): string {
  if (!rawUrl) return rawUrl;
  try {
    const parsed = new URL(rawUrl);
    if (parsed.hostname.endsWith('.sharepoint.com')) {
      parsed.searchParams.set('web', '1');
      return parsed.toString();
    }
    return rawUrl;
  } catch {
    return rawUrl;
  }
}
